import SNSShare from "./sns";

(() => {
    new SNSShare();
    
    var isClicked = false;
    var clickTimeout;

    window.addEventListener("message", (e) => {
        if(location.href.includes(e.origin) && e.data === 'kakao' && !isClicked) {
            isClicked = true;
            document.getElementById('share-kakao').click();
            clearTimeout(clickTimeout);
            clickTimeout = setTimeout(()=> {
                isClicked = false;
            }, 1000);
        }
    });

})();